export default __webpack_public_path__ + "static/AeonikLight-b3ec013f405f962fd38dd8f2343dcce9.woff";